export const SURVEY_AUDIENCES = ['COMPANY', 'CONSULTANT', 'BOTH'] as const;

export type SurveyAudience = (typeof SURVEY_AUDIENCES)[number];
